<script setup lang="ts">
import { ICON } from "@/lib/icons"
import type { OutingPrepEntrySummary } from "@/types/models"

const props = defineProps<{
  kitReady: boolean
  outstandingPrepCount: number
  unverifiedItemCount: number
  prepEntries: OutingPrepEntrySummary[]
}>()

function reasonLabel(entry: OutingPrepEntrySummary) {
  switch (entry.reason) {
    case "waiting_on":
      return `Waiting on ${entry.reason_detail}`
    case "on_loan":
      return `On loan to ${entry.reason_detail}`
    case "to_acquire":
      return "To acquire"
  }
}
</script>

<template>
  <section class="border-default bg-muted flex flex-col gap-4 rounded-lg border p-4">
    <div class="flex items-start gap-2">
      <UIcon
        :name="kitReady ? ICON.success : ICON.error"
        :class="kitReady ? 'text-success' : 'text-error'"
        class="size-5 shrink-0"
      />
      <div class="flex min-w-0 flex-1 flex-col gap-1">
        <p class="text-highlighted text-sm font-semibold">
          {{ kitReady ? "Kit ready" : "Kit not ready" }}
        </p>
        <p v-if="!kitReady" class="text-muted text-sm">
          {{ outstandingPrepCount }} outstanding prep
          {{ outstandingPrepCount === 1 ? "entry" : "entries" }} ·
          {{ unverifiedItemCount }} unverified {{ unverifiedItemCount === 1 ? "item" : "items" }}
        </p>
      </div>
      <UBadge :color="kitReady ? 'success' : 'error'" variant="subtle" size="sm">
        {{ kitReady ? "Ready" : "Blocked" }}
      </UBadge>
    </div>

    <ul v-if="prepEntries.length" class="divide-default divide-y">
      <li v-for="entry in prepEntries" :key="entry.id" class="flex flex-col gap-1 py-2">
        <span class="text-highlighted text-sm font-medium">{{ entry.name }}</span>
        <span class="text-muted text-xs">{{ reasonLabel(entry) }}</span>
      </li>
    </ul>
  </section>
</template>
